module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('customHeader'), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('customFooter')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73178bc6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./homepage/layout.vue
// module id = 39
// module chunks = 0